import React from 'react';

import dayjs from 'dayjs';

import { PagintaionParams } from 'shared/CustomPagination/CustomPagination';

import { CoachesBooking, SelectedBookingCoach } from 'features/coachesBooking';
import { WorkTime } from 'features/config';
import { AccountData } from 'features/user';

import BookingDescription from './BookingDescription';


interface Props {
  handleBooking: (arg: SelectedBookingCoach) => void;
  handleCheckDetail: (id: number) => void;
  items: CoachesBooking;
  params: PagintaionParams;
  workTime: WorkTime;
  userInfo: AccountData;
}

type CoachBooking = CoachesBooking[number];

function GraphColumns({
  handleBooking,
  handleCheckDetail,
  items,
  params,
  workTime,
  userInfo
}: Props) {
  return ([
    ...Array
      .from({
        length:
          (params.pageNumber * params.pageSize > params.itemsCount
            ? params.itemsCount - (params.pageNumber - 1) * params.pageSize
            : params.pageSize
          )
      })
      .map((_, i) => {
        const columnIndex = (params.pageNumber - 1) * params.pageSize + i;
        return ({
          title: items[0].columns[columnIndex].coachName,
          dataIndex: ['columns', columnIndex],
          width: 120,
          render: (column: CoachBooking['columns'][number], booking: CoachBooking, index: number) => (
            index !== 0
              ?
              <button
                key={`${booking.startTime} ${column.coachId} `}
                onClick={() => {
                  if (column.bookingId) {
                    handleCheckDetail(column.bookingId);
                  } else {
                    const bookingTime = dayjs(booking.startTime);
                    const isWorkTime =
                      (workTime.closed - bookingTime.hour() > 1) || (workTime.closed - bookingTime.hour() === 1 && bookingTime.minute() !== 30);
                    if (
                      isWorkTime &&
                      (userInfo.role !== 'coach' || userInfo.name === column.coachName)
                    ) {
                      handleBooking({
                        coachId: column.coachId,
                        startTime: dayjs(booking.startTime),
                        coachName: column.coachName
                      });
                    }
                  }
                }}
                style={{
                  cursor: 'pointer',
                  display: 'block',
                  backgroundColor: column.bookingId !== null ? 'rgba(0, 181, 75, 0.5)' : 'transparent',
                  height: '40px',
                  border: 'none',
                  position: 'relative',
                  borderBottom: (
                    column.bookingId === null
                    || column.isBookingEnd
                  )
                    ? '1px solid #f0f0f0'
                    : 'none',
                  width: '100%'
                }}
              >
                {
                  column.bookingId !== null && column.isBookingStart &&
                  (column.userName || column.coachName) && (
                    <BookingDescription
                      userName={column.userName}
                      coachName={column.coachName}
                      courtName={column.courtName}
                    />
                  )
                }
              </button>
              : (
                <div style={{ height: '17px', borderBottom: '1px solid #f0f0f0' }}></div>
              )
          ),
          sorter: () => 0,
          sortIcon: () => null,
          onCell: () => ({
            style: {
              padding: 0,
              borderTop: 'none',
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: '1px solid #f0f0 f0',
            }
          }),
        });
      }),
  ]);
}

export default GraphColumns;
